import { useSelector as useReduxSelector, useDispatch as useReduxDispatch, TypedUseSelectorHook } from 'react-redux';
import { root } from 'store';

export const useSelector: TypedUseSelectorHook<root.RootState> = useReduxSelector;
export const useDispatch = () => useReduxDispatch<root.AppDispatch>();
